import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: "app-cell-phone-directory",
    templateUrl: "./cell-phone-directory.component.html",
    styleUrls: ["./cell-phone-directory.component.scss"],
    standalone: false
})
export class CellPhoneDirectoryComponent {
  @Input() set setPhone(_value: string) {
    if (!_value) return;
    let formatedPhone = this.formatPhone(_value);
    this.phoneForm.setValue({
      phoneNumber: formatedPhone,
    });
  }

  /**
   * Titulo de la card
   */
  @Input() formTitle: string | number | null;

  /**
   * Placeholder del input para el telefono
   */
  @Input() formPlaceholder: string = "";

  /**
   * Bandera para mostrar el boton del directorio
   */
  @Input() showDirectory: boolean = false;

  /**
   * Callback para abrir el directorio
   */
  @Input() openDirectory: () => void;

  /**
   * Emite el valor del input para el telefono
   */
  @Output() onPhoneValue: EventEmitter<
  string | undefined> = new EventEmitter(undefined);

  /**
   * Formulario para el campo del telefono
   */
  phoneForm = new FormGroup({
    phoneNumber: new FormControl('', [
      Validators.maxLength(12),
      Validators.minLength(12),
      Validators.required,
      Validators.pattern(/^\d{2} \d{4} \d{4}$/)
    ]),
  });

  constructor() {
    this.validateField();
  }

  formatPhone(phone: string): string {
    return phone.replace(
      /(\d{2})(\d{0,4})(\d{0,4})/,
      (_: string, g1: string, g2: string, g3: string) => {
        return [g1, g2, g3].filter(Boolean).join(" ");
      }
    );
  }
  /**
   * Emite el valor solo cuando el numero de telefono es valido sino emite un valor null
   */
  validateField() {
    this.phoneForm.valueChanges.subscribe(() => {
      const { phoneNumber } = this.phoneForm.controls;
      const copy = {...phoneNumber};
      const value = copy.value.replace(/\s/g, '');
      this.onPhoneValue.emit(phoneNumber.valid ? value : null);
    });
  }

  onInput(_value: string): void {
    this.phoneForm.setValue({ phoneNumber: this.formatPhone(_value) });
  }
}
